const FormNavigation = ({ step, totalSteps, prevStep, nextStep, isLoading, loading, nextDisabled = false }) => {
  // Combine loading states to prevent any action during submission
  const isDisabled = isLoading || loading;

  return (
    <div className="button-group">
      {step > 1 && (
        <button
          type="button"
          onClick={prevStep}
          className="btn back"
          disabled={isDisabled}
        >
          Prev
        </button>
      )}
      {step < totalSteps && (
        <button
          type="button"
          onClick={nextStep}
          className="btn next"
          disabled={isDisabled || nextDisabled}
        >
          {isLoading ? 'Please Wait…' : 'Next'}
        </button>
      )}
      {step === totalSteps && (
        <button
          type="button"
          onClick={nextStep}
          className="btn submit"
          disabled={isDisabled || nextDisabled}
        >
          {loading ? 'Submitting…' : 'Submit'}
        </button>
      )}
    </div>
  );
};

export default FormNavigation;
